import React from 'react';
import { useTranslation } from 'react-i18next';
import Reveal from '../Reveal';
import {
  SalesSectionWrap,
  Container,
  Header,
  HeaderCopy,
  SectionTag,
  SectionTitle,
  SectionSubtitle,
  AsideCard,
  ProcessGrid,
  ProcessCard,
  ProofGrid,
  ProofCard,
  FaqSection,
  FaqTitle,
  FaqItem,
  FaqQuestion,
  FaqAnswer,
} from './SalesSection.styles';

const SalesSection: React.FC = () => {
  const { t } = useTranslation();

  const process = [
    { title: t('sales.process0Title'), desc: t('sales.process0Desc') },
    { title: t('sales.process1Title'), desc: t('sales.process1Desc') },
    { title: t('sales.process2Title'), desc: t('sales.process2Desc') },
    { title: t('sales.process3Title'), desc: t('sales.process3Desc') },
  ];

  const proof = [
    { label: t('sales.metric0Label'), value: t('sales.metric0Value') },
    { label: t('sales.metric1Label'), value: t('sales.metric1Value') },
    { label: t('sales.metric2Label'), value: t('sales.metric2Value') },
    { label: t('sales.metric3Label'), value: t('sales.metric3Value') },
  ];

  const faq = [
    { question: t('sales.faq0Question'), answer: t('sales.faq0Answer') },
    { question: t('sales.faq1Question'), answer: t('sales.faq1Answer') },
    { question: t('sales.faq2Question'), answer: t('sales.faq2Answer') },
    { question: t('sales.faq3Question'), answer: t('sales.faq3Answer') },
  ];

  return (
    <SalesSectionWrap>
      <Container>
        <Reveal>
          <Header>
            <HeaderCopy>
              <SectionTag>{t('sales.tag')}</SectionTag>
              <SectionTitle>
                {t('sales.title')} <span>{t('sales.titleGradient')}</span>
              </SectionTitle>
              <SectionSubtitle>{t('sales.subtitle')}</SectionSubtitle>
            </HeaderCopy>

            <AsideCard>
              <span>{t('sales.asideLabel')}</span>
              <h3>{t('sales.asideTitle')}</h3>
              <p>{t('sales.asideText')}</p>
            </AsideCard>
          </Header>
        </Reveal>

        <Reveal delay={80}>
          <ProcessGrid>
            {process.map((step) => (
              <ProcessCard key={step.title}>
                <strong>{step.title}</strong>
                <p>{step.desc}</p>
              </ProcessCard>
            ))}
          </ProcessGrid>
        </Reveal>

        <Reveal delay={120}>
          <ProofGrid>
            {proof.map((item) => (
              <ProofCard key={item.label}>
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </ProofCard>
            ))}
          </ProofGrid>
        </Reveal>

        <Reveal delay={150}>
          <FaqSection>
            <FaqTitle>{t('sales.faqTitle')}</FaqTitle>
            {faq.map((item) => (
              <FaqItem key={item.question}>
                <FaqQuestion>{item.question}</FaqQuestion>
                <FaqAnswer>{item.answer}</FaqAnswer>
              </FaqItem>
            ))}
          </FaqSection>
        </Reveal>
      </Container>
    </SalesSectionWrap>
  );
};

export default SalesSection;